import React, { useState, createContext } from "react";
  
export const FilterDataContext = createContext();

export const FilteredDataProvider = ({children}) => {

    // filter for checkins

    const [filterDataBuyer, setFilterDataBuyer] = useState(null);
    const [filterDataSupplier, setFilterDataSupplier] = useState(null);
    const [filterDataFromDate, setFilterDataFromDate] = useState("");
    const [filterDataToDate, setFilterDataToDate] = useState("");
    const [filterDataStatus, setFilterDataStatus] = useState("");
    
    // filter for plans

    const [plansFromDate, setPlansFromDate] = useState("")
    const [plansToDate, setPlansToDate] = useState("")


    function clearContextState() {
        setFilterDataBuyer(null);
        setFilterDataSupplier(null);
        setFilterDataFromDate("");
        setFilterDataToDate("");
        setFilterDataStatus("");
        setPlansFromDate("");
        setPlansToDate("");
    }

    const value = {
        filterDataBuyer, setFilterDataBuyer, filterDataSupplier, setFilterDataSupplier, filterDataFromDate, setFilterDataFromDate,
        filterDataToDate, setFilterDataToDate, filterDataStatus, setFilterDataStatus, clearContextState, plansFromDate, setPlansFromDate,
        plansToDate, setPlansToDate,
    }

    return(
        <FilterDataContext.Provider value={value}>
            {children}
        </FilterDataContext.Provider>
    )

}